import type { Router } from 'vue-router';

// Late-bound handle for the global router instance. main.ts (appShell) sets
// this immediately after `createRouter`, so stores can read route meta from
// arbitrary callers without going through `useRouter()` — which needs a live
// component setup context and is unreliable from event-handler callsites.
let registeredRouter: Router | null = null;

export function registerRouter(router: Router): void {
  registeredRouter = router;
}

/**
 * Is the handle bound yet? For the rare caller that runs EAGERLY — a store-level
 * `watch`, whose source getter fires the moment the store is built rather than
 * when someone reads it. `getRouter()` throwing is the right behaviour for every
 * lazy read (a missing router there is a genuine wiring bug), but an eager one
 * would make merely *touching* the store depend on app boot order.
 */
export function isRouterRegistered(): boolean {
  return registeredRouter !== null;
}

export function getRouter(): Router {
  if (!registeredRouter) {
    throw new Error('Router accessed before registerRouter() was called');
  }
  return registeredRouter;
}
